// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bo-core/grids/GroupsGrid/components/createGroupModal/createGroupModal.css
// module id = 773
// module chunks = 1